// @flow
export default (hostname: ?string, formattedSearchUrl: string): string => {
    if (hostname) {
        const sanitizedHostname = hostname.replace(/(^\w+:|^)\/\/|\//g, '');

        return `https://${sanitizedHostname}${formattedSearchUrl}`;
    }

    return formattedSearchUrl;
};
